<template>
    <div class="slideshow">
      <div class="slides"
      @mouseover="pauseInterval"
      @mouseleave="resumeInterval"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <slot v-for="item in slides" :data="item"></slot>
      </div>
      <button @click="prevSlide" class="nav prev">&lt;</button>
      <button @click="nextSlide" class="nav next">&gt;</button>
      <div class="d-flex mt-2 px-3 overflow-hidden slideshow-thumbnail" ref="scrollContainer">
        <div :class="`andon-thumbnail ${currentIndex == index ? 'andon-selected' : ''}`" v-for="(item, index) in slides" :key="index" :ref="'item-' + index" @click="currentIndex = index"  role="button">
          {{ item.name }}
        </div>
      </div>
    </div>
  </template>
  <style scoped lang="scss">
    .slideshow-thumbnail {
      column-gap: 10px;
    }

    .andon-thumbnail {
      padding: 1rem;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-weight: 600;
      text-wrap: nowrap;

      &.andon-selected {
        border: 1px solid #00ff00;
        color: #00ff00;
      }
    }
  </style>
  <script>
  export default {
    props : {
      slides : {
        default : function() {
          return [];
        },
        type: Array,
      },
      change : {},
    },
    data() {
      return {
        currentIndex: 0,
        interval: {}
      };
    },
    methods: {
      nextSlide() {
        if ((this.currentIndex + 1) == this.slides.length) {
          if (this.interval) {
            clearInterval(this.interval);
          }
          this.$emit("change", true);
        }
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        this.scrollToElement(this.currentIndex);
      },
      prevSlide() {
        this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      },
      scrollToElement(index) {
        const element = this.$refs['item-' + index][0];
        const container = this.$refs.scrollContainer;

        const elementLeft = element.offsetLeft;
        const elementRight = elementLeft + element.offsetWidth;
        const containerLeft = container.scrollLeft;
        const containerRight = containerLeft + container.clientWidth;
        
        if (elementLeft < containerLeft || elementRight > containerRight) {
          container.scrollLeft = elementLeft;
        }
      },
      pauseInterval() {
        clearInterval(this.interval);
      },
      resumeInterval() {
        this.startInterval();
      },
      startInterval() {
        this.interval = setInterval(this.nextSlide, 10000);
      }
    },
    mounted() {
    },
    watch : {
      slides : {
			  handler: function() {
          if (this.interval) {
            clearInterval(this.interval);
          }
          this.startInterval();
        },
        deep: true,
      },
    },
    beforeDestroy() {
      clearInterval(this.interval);
    }
  };
  </script>
  
  <style scoped lang="scss">
  .slideshow {
    position: relative;
    /*width: 600px;
    height: 400px;*/
    overflow: hidden;
    margin: auto;

    .slides {
        display: flex;
        transition: transform 0.5s ease-in-out;
    }
    
    .slide {
        min-width: 100%;
        box-sizing: border-box;
    }
    
    img {
        width: 50%;
        height: auto;
    }
    
    .nav {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(0, 0, 0, 0.5);
        color: white;
        border: none;
        padding: 10px;
        cursor: pointer;
    }
    
    .prev {
        left: 10px;
    }
    
    .next {
        right: 10px;
    }
  }
  </style>
  